import { combineLatest, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { defineComponent } from 'vue'

import { Alias } from '@skinsoft/types'
import { aliasSelectors, workSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const Author = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['work', 'authorId'],
    template: require('./author.html'),
    data() {
        return {
            aliases: null as any as Alias[],
            aliasSelectors,
            error: null as any as Error,
        }
    },
    created() {
        this.subscribe();
    },
    methods: {
        subscribe() {

            const aliasIds = this.work !== undefined ? workSelectors.aliases(this.work) : [this.authorId];
            if (!this.authorId || aliasIds.length === 0) {
                this.aliases = [];
                return;
            }

            this.subscribeTo(
                combineLatest<Alias>(
                    aliasIds.map(aliasId => this.$aliasDataStore.fetchOne(aliasId)),
                ).pipe(
                    catchError(error => {
                        // tslint:disable-next-line:no-console
                        console.error(error);
                        this.error = error;
                        return of([]);
                    }),
                ),
                aliases => {
                    this.aliases = aliases as Alias[];
                },
                'aliases',
            );
        },
    },
    watch: {
        work() {
            this.unsubscribeFrom('aliases');
            this.subscribe();
        },
        aliases(value) {
            if (!value) {
                return;
            }

            this.$emit('ready');
        },
    },
})
